export enum PricingTab {
  Base = 'base',
  Component = 'component',
  Adjustment = 'adjustment',
}
